export const simulationChartType = Object.freeze({
  CUMULATIVE_PROBABILITY: 'cumulative-probability',
  OPERATION_DURATIONS: 'operation-durations',
  TIME_DEPTH: 'time-depth',
  ACTIVITY_DURATIONS: 'activity-durations',
  COST_ITEM_OVERVIEW: 'cost-item-overview',
  RISKS: 'risks',
  SECTION_DURATIONS: 'section-durations',
  MODIFIERS: 'modifiers',
  SECTION_WATERFALL: 'Section Waterfall',
  PROBABILITY_DENSITY: 'probability-density',
  AFE_REPORT: 'afe-report',
});

export const timeCostView = Object.freeze({
  TIME: 'time',
  COST: 'cost',
  COSTS: 'costs',
  DEPTH: 'depth',
});

export const probabilities = Object.freeze({
  MEAN: 'mean',
  P10: '10',
  P50: '50',
  P90: '90',
});

export const simulationStatuses = Object.freeze({
  QUEUED: 'Queued',
  INITIALISING: 'Initialising',
  PREPARING_RESULTS: 'PreparingResults',
  FINISHED: 'Finished',
});
